import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
// import Image from "../components/image"
import SEO from "../components/seo"

const IndexPage = () => (
  
  <Layout>
    <SEO title="Home" />
    
      {/* <Image /> */}
    
    {/* <Link to="/page-2/">Go to page 2</Link> <br /> */}
    <p>Welcome to my site</p>
    <Link to="/resume/">Go to Resume</Link> <br />
  </Layout>
)



export default IndexPage
